import type { RdVerdict } from '@dcc-erp/shared';

type Tone = 'positive' | 'negative' | 'warning' | 'neutral';

// Map a per-taxpayer RD verdict to the prototype badge tone + a plain-Thai label.
// null = never verified yet (or verify disabled) → neutral "ยังไม่ตรวจ".
const VERDICT: Record<RdVerdict, { tone: Tone; label: string }> = {
  VERIFIED: { tone: 'positive', label: 'ตรงกับสรรพากร' },
  NOT_VAT_REGISTERED: { tone: 'negative', label: 'ไม่ได้จด VAT' },
  INVALID_TAX_ID: { tone: 'negative', label: 'เลขภาษีไม่ถูกต้อง' },
  NAME_MISMATCH: { tone: 'warning', label: 'ชื่อไม่ตรง' },
  BRANCH_MISMATCH: { tone: 'warning', label: 'สาขาไม่ตรง' },
  UNKNOWN: { tone: 'neutral', label: 'ตรวจไม่ได้' },
  DISABLED: { tone: 'neutral', label: 'ปิดการตรวจ' },
};

export function SupplierVerdictChip({ verdict }: { verdict: RdVerdict | null }) {
  const v = verdict ? VERDICT[verdict] : { tone: 'neutral' as const, label: 'ยังไม่ตรวจ' };
  return (
    <span className={`badge ${v.tone}`}>
      <span className="bdot" />
      {v.label}
    </span>
  );
}
